import React from 'react';
import { FormattedMessage } from 'react-intl';
import { classNames } from '../../../utils/classNames';
import FormBase, { FormItemState } from '../FormBase';


export default function Selector(props: {
    titleId?: string,
    id?: string,
    feedBackId?: string,
    state?: FormItemState,
    object?: any,
    onChange?: (index: any) => void,
    defaultValue?: { value?: string, disabled?: boolean },
    value?: any
    disabled?: boolean,
    unTrans?: boolean,
}) {

    let chart = [];
    if (props.defaultValue) {
        if (props.unTrans && props.defaultValue.value !== 'select_all') {
            chart.push(
                <option value="" key={-1} disabled={props.defaultValue!.disabled}>
                    {props.defaultValue.value}
                </option>
            );
        } else {
            chart.push(
                <FormattedMessage
                    id={props.defaultValue.value}
                    description={props.defaultValue.value}
                    defaultMessage={props.defaultValue.value}
                    key={-1}
                >
                    {(text) => {
                        return (
                            <option value="" key={-1} disabled={props.defaultValue!.disabled}>
                                {text}
                            </option>
                        )
                    }}
                </FormattedMessage>
            );
        }

    }
    for (let key in props.object) {
        let value: string = props.object[key];
        if (props.unTrans) {
            chart.push(
                <option value={key} key={chart.length}>
                    {value}
                </option>
            )
        } else {
            chart.push(
                <FormattedMessage
                    id={value}
                    description={value}
                    defaultMessage={value}
                    key={chart.length}
                >
                    {(text) => {
                        return (
                            <option value={key} >
                                {text}
                            </option>
                        )
                    }}
                </FormattedMessage>
            )
        }

    }

    function handlerChanged(e: React.ChangeEvent<HTMLSelectElement>) {
        if (props.onChange)
            props.onChange(e.target.value);
    }

    return (
        <FormBase titleId={props.titleId} id={props.id} feedBackId={props.feedBackId}>
            <select
                className={classNames("custom-select form-control", props.state)}
                id={props.id}
                onChange={handlerChanged}
                value={props.value}
                disabled={props.disabled}
            >
                {chart}
            </select>
        </FormBase>
    )
}